import { IAP_DASHBOARD_MODES } from 'components/IAP/ICSConstants';

/** Working = next OP package; number = historical/started OP package. */
export type FormsView = 'working' | number;

export function isWorkingFormsView(view: FormsView): view is 'working' {
  return view === 'working';
}

export function parseFormsViewParam(raw: string | null): FormsView | undefined {
  if (raw === 'working') return 'working';
  if (raw != null && /^\d+$/.test(raw)) {
    return Number.parseInt(raw, 10);
  }
  return undefined;
}

export function serializeFormsView(view: FormsView): string {
  return view === 'working' ? 'working' : String(view);
}

/** Derive legacy mode for callers that still key off current/future. */
export function formsViewToMode(view: FormsView): string {
  return view === 'working'
    ? IAP_DASHBOARD_MODES.FUTURE
    : IAP_DASHBOARD_MODES.CURRENT;
}

/**
 * Resolve formsView from URL (prefer formsView) or legacy mode. When
 * mode=current without formsView, use currentPeriodNumber.
 */
export function resolveFormsView(args: {
  formsViewParam: string | null;
  modeParam: string | null;
  currentPeriodNumber: number;
}): FormsView {
  const fromParam = parseFormsViewParam(args.formsViewParam);
  if (fromParam !== undefined) return fromParam;

  if (args.modeParam === IAP_DASHBOARD_MODES.FUTURE) {
    return 'working';
  }

  return args.currentPeriodNumber;
}

/**
 * Period number used to filter period-tagged forms.
 *
 * Takes the working period rather than deriving it, because "working" is not always current + 1: during Initial
 * Response it is 0. See `utils/workingOperationalPeriod`.
 */
export function effectivePeriodNumber(
  formsView: FormsView,
  workingPeriodNumber: number
): number {
  return formsView === 'working' ? workingPeriodNumber : formsView;
}

export function formatWorkingOperationalPeriodLabel(
  workingPeriodNumber: number
): string {
  return `Working OP ${workingPeriodNumber}`;
}

export function formatOperationalPeriodLabel(periodNumber: number): string {
  return `Operational Period ${periodNumber}`;
}
